(() => {
  const initialize = () => {
    document.querySelectorAll('[data-shulin-hero-video]').forEach((root) => {
      if (root.dataset.videoInitialized === 'true') return;
      const video = root.querySelector('video');
      if (!video) return;
      root.dataset.videoInitialized = 'true';
      const mobileLayout = window.matchMedia('(max-width: 749px)').matches;
      const preferredSource = mobileLayout ? video.dataset.mobileSource : video.dataset.desktopSource;
      const preferredPoster = mobileLayout ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      if (preferredPoster) video.poster = preferredPoster;
      if (preferredSource && video.currentSrc !== preferredSource) video.src = preferredSource;
      video.defaultMuted = true;
      video.muted = true;
      video.volume = 0;
      video.playsInline = true;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const tryPlay = () => {
        if (!document.documentElement.contains(root) || document.hidden || reducedMotion.matches || !video.paused) return;
        const bounds = root.getBoundingClientRect();
        if (bounds.bottom <= 0 || bounds.top >= window.innerHeight) return;
        try {
          const request = video.play();
          if (request && typeof request.catch === 'function') request.catch(() => {});
        } catch (error) {}
      };
      if (reducedMotion.matches) video.pause();
      video.addEventListener('loadeddata', tryPlay, { once: true });
      video.addEventListener('canplay', tryPlay, { once: true });
      document.addEventListener('WeixinJSBridgeReady', tryPlay, { once: true });
      document.addEventListener('touchend', tryPlay, { once: true, passive: true });
      document.addEventListener('click', tryPlay, { once: true, passive: true });
      window.addEventListener('pageshow', tryPlay);
      document.addEventListener('visibilitychange', () => {
        if (!document.documentElement.contains(root)) return;
        if (document.hidden) video.pause();
        else tryPlay();
      });
      const motionChanged = () => {
        if (reducedMotion.matches) video.pause();
        else tryPlay();
      };
      if (typeof reducedMotion.addEventListener === 'function') reducedMotion.addEventListener('change', motionChanged);
      else if (typeof reducedMotion.addListener === 'function') reducedMotion.addListener(motionChanged);
      tryPlay();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

